import {menuItems, subMenu} from '../context-menu/menu-items';
import {SelectionTypes} from 'src/app/shared/models/diagram-interactions.interface';

const commonMenuItems = {
  [menuItems.copy]: {
    icon: 'copy'
  },
  [menuItems.delete]: {
    icon: 'delete',
    iconColor: 'warn'
  }
};

export const subMenuIcons = {
  [menuItems.top]: 'layout-align-top',
  [menuItems.middleVertical]: 'layout-align-center',
  [menuItems.bottom]: 'layout-align-bottom',
  [menuItems.left]: 'layout-align-left',
  [menuItems.middleHorizontal]: 'layout-align-middle',
  [menuItems.right]: 'layout-align-right',
  [menuItems.vertically]: 'layout-distribute-vertical',
  [menuItems.horizontally]: 'layout-distribute-horizontal',
  [menuItems.widthHeight]: 'dimensions',
  [menuItems.width]: 'arrow-autofit-width',
  [menuItems.height]: 'arrow-autofit-height'
};

export const contextBarModel = {
  [SelectionTypes.Activity]: {
    ...commonMenuItems,
    [menuItems.generate]: {
      icon: 'wand',
      tooltip: 'CONTEXT_BAR.GENERATE_RECORDS',
      items: [menuItems.generateRequirements, menuItems.generateStoriesAI]
    },
    [menuItems.addToCard]: {
      icon: 'resources',
      tooltip: 'CONTEXT_BAR.ADD_TO_THIS',
      items: [menuItems.addAttribute, menuItems.addResource, menuItems.addFooterText]
    },
    [menuItems.addDocumentation]: {
      icon: 'file-plus',
      ...subMenu.addDocumentation
    },
    [menuItems.addChange]: {
      icon: 'changes',
      items: [
        menuItems.addRequirement,
        menuItems.addStory,
        menuItems.pasteRequirementLink,
        menuItems.pasteStoryLink
      ]
    },
    [menuItems.renumberActivity]: {
      icon: '123',
      q9Track: 'CONTEXT_TOOLBAR.ACTIVITY.RENUMBER'
    },
    [menuItems.drilldown]: {
      icon: 'move-down',
      tooltip: 'CONTEXT_BAR.DRILLDOWN',
      ...subMenu.drilldown
    },
    [menuItems.theme]: {
      icon: 'themes',
      tooltip: 'CONTEXT_BAR.CHANGE_THEME',
      ...subMenu.theme
    },
    [menuItems.align]: {
      icon: subMenuIcons[menuItems.left],
      ...subMenu.align
    },
    [menuItems.distribute]: {
      icon: subMenuIcons[menuItems.vertically],
      ...subMenu.distribute
    },
    [menuItems.matchSize]: {
      icon: 'resize',
      ...subMenu.matchSize
    },
    [menuItems.themePasteMenu]: {
      icon: 'themes',
      ...subMenu.themePasteMenu
    }
  },
  [SelectionTypes.Sticker]: {
    ...commonMenuItems,
    [menuItems.font]: {
      icon: 'text_icon_v2',
      q9Track: 'CONTEXT_TOOLBAR.STICKER.CHANGE_FONT'
    },
    [menuItems.tags]: {
      icon: 'tags',
      tooltip: 'CONTEXT_BAR.TAGS',
      q9Track: 'CONTEXT_TOOLBAR.STICKER.CHANGE_TAGS'
    },
    [menuItems.theme]: {
      icon: 'themes',
      items: [menuItems.copyStyle, menuItems.pasteStyle]
    }
  },
  [SelectionTypes.Text]: {
    ...commonMenuItems
  }
};
